import * as React from 'react'
import { __DEV__ } from '@mote/helpers/constants'
import type { MarginProps } from '@xstyled/styled-components'
import styled, { css, th, x } from '@xstyled/styled-components'
import type { HTMLXStyledProps } from '../../system'
import { forwardRef } from '../../system'
import type { IconProps } from '../icon'
import { Icon } from '../icon'

export interface ListProps extends HTMLXStyledProps<'ul'> {
  spacing?: MarginProps['margin']
}

export const List = forwardRef<ListProps, 'ul'>(
  ({ children, ...props }, ref) => {
    return (
      <Root ref={ref} role='list' listStyleType='none' {...props}>
        {
          React.Children.toArray(children).filter(child =>
            React.isValidElement(child)
          ) as React.ReactElement[]
        }
      </Root>
    )
  }
)

if (__DEV__) {
  List.displayName = 'List'
}

export interface ListItemProps extends HTMLXStyledProps<'li'> {}

export const ListItem = forwardRef<ListItemProps, 'li'>((props, ref) => {
  return <x.li ref={ref} {...props} />
})

if (__DEV__) {
  ListItem.displayName = 'ListItem'
}

export const ListIcon = forwardRef<IconProps, 'svg'>((props, ref) => {
  return (
    <Icon ref={ref} role='presentation' mr={2} {...props} display='inline' />
  )
})

if (__DEV__) {
  ListIcon.displayName = 'ListIcon'
}

const Root = styled.ulBox<ListProps>`
  ${({ spacing }) =>
    spacing &&
    css`
      & > *:not(style) ~ *:not(style) {
        margin-top: ${th.space(spacing)};
      }
    `}
`
